import { lazy, Suspense } from "react";
import { BUILDER_ROUTES, USER_ROUTES } from "../constants/appRoutes";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";
const SalesLocationHistoryPage = lazy(
  () => import("../pages/builder/SalesTeam/LocationHistory")
);
const EditLeadPage = lazy(() => import("../pages/admin/Leads/EditLead"));

const ReportLayout = lazy(() => import("../pages/admin/Reports"));
const ReportsList = lazy(() => import("../pages/admin/Reports/ReportsList"));
const SingleReport = lazy(() => import("../pages/admin/Reports/SingleReport"));

const Meetings = lazy(() => import("../pages/agent/Meeting/Meeting"));
const Projects = lazy(
  () => import("../pages/admin/RealEstate/Projects/Projects")
);
const NewProject = lazy(
  () => import("../pages/admin/RealEstate/Projects/NewProject")
);
const Profile = lazy(() => import("../pages/admin/Profile/Profile"));

const EnquiryListPage = lazy(
  () => import("../pages/admin/Enquiry/EnquiryList")
);
const ViewEnquiryForm = lazy(
  () => import("../pages/admin/Enquiry/ViewEnquiryForm")
);
const Properties = lazy(
  () => import("../pages/admin/RealEstate/Properties/Properties")
);
const NewProperty = lazy(
  () => import("../pages/admin/RealEstate/Properties/NewProperty")
);
const ViewProperty = lazy(
  () => import("../pages/admin/RealEstate/Properties/ViewProperty")
);
const ViewProject = lazy(
  () => import("../pages/admin/RealEstate/Projects/ViewProject")
);
const BuilderDashboard = lazy(() => import("../pages/builder/Dashboard"));
const Agent = lazy(() => import("../pages/builder/Agent/Agent"));
const NewAgent = lazy(() => import("../pages/builder/Agent/NewAgent"));
const AgentDetail = lazy(() => import("../pages/admin/Agent/AgentDetail"));
const ViewMeeting = lazy(() => import("../pages/agent/Meeting/ViewMeeting"));
const SalesTeam = lazy(() => import("../pages/builder/SalesTeam/SalesTeam"));
const NewSalesMember = lazy(
  () => import("../pages/builder/SalesTeam/NewSalesMember")
);
const Leads = lazy(() => import("../pages/admin/Leads/Leads"));

const BuilderRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-[100vh]">
          <Loader />
        </div>
      }
    >
      <Routes>
        <Route path={USER_ROUTES.ROOT} element={<BuilderDashboard />}></Route>
        <Route path={BUILDER_ROUTES.PROPERTIES} element={<Properties />} />
        <Route path={BUILDER_ROUTES.NEW_PROPERTIES} element={<NewProperty />} />
        <Route path={BUILDER_ROUTES.VIEW_PROPERTY} element={<ViewProperty />} />
        <Route
          path={BUILDER_ROUTES.EDIT_PROPERTIES}
          element={<NewProperty />}
        />
        <Route path={BUILDER_ROUTES.PROJECTS} element={<Projects />} />
        <Route path={BUILDER_ROUTES.VIEW_PROJECT} element={<ViewProject />} />
        <Route path={BUILDER_ROUTES.NEW_PROJECTS} element={<NewProject />} />
        <Route path={BUILDER_ROUTES.EDIT_PROJECTS} element={<NewProject />} />
        <Route path={BUILDER_ROUTES.ENQUIRY} element={<EnquiryListPage />} />
        <Route
          path={BUILDER_ROUTES.VIEW_ENQUIRY}
          element={<ViewEnquiryForm />}
        />
        <Route path={BUILDER_ROUTES.MEETINGS} element={<Meetings />} />
        <Route path={BUILDER_ROUTES.VIEW_MEETING} element={<ViewMeeting />} />
        <Route path={BUILDER_ROUTES.AGENT} element={<Agent />} />
        <Route path={BUILDER_ROUTES.NEW_AGENT} element={<NewAgent />} />
        <Route path={BUILDER_ROUTES.EDIT_AGENT} element={<NewAgent />} />
        <Route path={BUILDER_ROUTES.VIEW_AGENT} element={<AgentDetail />} />
        <Route path={BUILDER_ROUTES.LEADS} element={<Leads />} />
        <Route
          path={BUILDER_ROUTES.LEADS_EDIT_LEAD_ID}
          element={<EditLeadPage isEdit={true} />}
        />
        {/* SALES TEAM */}
        <Route path={BUILDER_ROUTES.SALES_TEAM} element={<SalesTeam />} />
        <Route
          path={BUILDER_ROUTES.LOCATION_HISTORY_SALES_TEAM_ID}
          element={<SalesLocationHistoryPage />}
        />
        <Route
          path={BUILDER_ROUTES.LEADS_VIEW_LEAD_ID}
          element={<EditLeadPage isEdit={false} />}
        />
        <Route
          path={BUILDER_ROUTES.NEW_SALES_TEAM}
          element={<NewSalesMember />}
        />
        <Route
          path={BUILDER_ROUTES.EDIT_SALES_TEAM}
          element={<NewSalesMember />}
        />
        <Route path={BUILDER_ROUTES.PROFILE} element={<Profile />}></Route>
        <Route
          path={BUILDER_ROUTES.REPORTS_PROPERTY_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={BUILDER_ROUTES.REPORTS_PROPERTY_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route
          path={BUILDER_ROUTES.REPORTS_PROJECT_LIST}
          element={
            <ReportLayout>
              <ReportsList />
            </ReportLayout>
          }
        />
        <Route
          path={BUILDER_ROUTES.REPORTS_PROJECT_ID}
          element={
            <ReportLayout>
              <SingleReport />
            </ReportLayout>
          }
        />
        <Route
          path={USER_ROUTES.NOT_FOUND}
          element={<Navigate to={BUILDER_ROUTES.ROOT} />}
        />
      </Routes>
    </Suspense>
  );
};

export default BuilderRoutes;
